import { bulkAssignRidersToInvoiceGroup } from '@rideiq/organizers/api/services/Billing';
import { QueryParamsForAssignRiders } from '@rideiq/organizers/types';
import { useToastStore } from '@rideiq/shared/stores/toastStore';

import { InvoiceGroupOption } from '../../InvoiceGroupDropdown';

interface UseMoveRidersToInvoiceGroupOptions {
  selectedRiderIds: number[];
  isAllFilteredSelected: boolean;
  totalCount: number;
  queryParams: QueryParamsForAssignRiders;
  onSuccess: () => void;
}

export const useMoveRidersToInvoiceGroup = ({
  selectedRiderIds,
  isAllFilteredSelected,
  totalCount,
  queryParams,
  onSuccess,
}: UseMoveRidersToInvoiceGroupOptions) => {
  const { addToast } = useToastStore();

  const riderCount = isAllFilteredSelected ? totalCount : selectedRiderIds.length;
  const riderLabel = riderCount === 1 ? 'rider' : 'riders';

  const submit = async (invoiceGroup: InvoiceGroupOption) => {
    const response = await bulkAssignRidersToInvoiceGroup(
      Number(invoiceGroup.value),
      isAllFilteredSelected ? 'all' : selectedRiderIds,
      queryParams
    );

    if (response.type === 'error') {
      addToast({ severity: 'error', message: 'Failed to move riders. Please try again.' });
    } else {
      addToast({ severity: 'success', message: `${riderCount} ${riderLabel} moved to ${invoiceGroup.label}.` });
      onSuccess();
    }
  };

  return { submit, riderCount, riderLabel };
};
